import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const fetcher = () => TablaComunService.getAsSelect(TiposTablaComunConstant.TIPOEXISTENCIA).then(({ data }) => data)

const TipoExistenciaSelect = props => {
  const { data: tiposExistencia } = useSwr('select_tipoExistencia', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {tiposExistencia.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(TipoExistenciaSelect)
